import { useQuery } from '@tanstack/react-query';
import { usageService } from '@/services/usageService';

export function useUsageSummary(period?: string) {
  return useQuery({
    queryKey: ['admin', 'usage', 'summary', period],
    queryFn: () => usageService.getSummary(period),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useUsageByType(period?: string) {
  return useQuery({
    queryKey: ['admin', 'usage', 'by-type', period],
    queryFn: () => usageService.getByType(period),
    staleTime: 1000 * 60 * 5,
  });
}

export function useUsageByDay(period?: string) {
  return useQuery({
    queryKey: ['admin', 'usage', 'by-day', period],
    queryFn: () => usageService.getByDay(period),
    staleTime: 1000 * 60 * 5,
  });
}

export function useTopUsers(limit?: number, period?: string) {
  return useQuery({
    queryKey: ['admin', 'usage', 'top-users', limit, period],
    queryFn: () => usageService.getTopUsers(limit, period),
    staleTime: 1000 * 60 * 5,
  });
}
